import { inject, Injectable, isDevMode } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(langPath: string) {
        // Avoid stale browser caches during development. In production we keep the URL stable.
        const cacheBuster = isDevMode() ? `?v=${Date.now()}` : '';
        return this.http.get<Translation>(`./assets/i18n/${langPath}.json${cacheBuster}`);
    }
}
